<app-loading-bar />
<p-toast />
<router-outlet />